import React, { forwardRef, memo } from 'react'
import styled from 'styled-components'
import { FormElementContainer, Label, ErrorMessage, baseInputStyles } from '../styled'

import { Spacings } from '@styles'

const StyledTextarea = styled.textarea`
	${baseInputStyles}
	resize: none;
	min-height: ${Spacings.SPACING_16B};
	line-height: 1.45;
`

const Textarea = forwardRef(({
	id,
	label,
	error,
	disabled,
	className,
	rows = 3,
	...props
}, ref) => {
	const hasError = !!error

	return (
		<FormElementContainer className={className}>
			{label && <Label htmlFor={id} disabled={disabled}>{label}</Label>}
			<StyledTextarea
				ref={ref}
				id={id}
				rows={rows}
				disabled={disabled}
				$hasError={hasError}
				{...props}
			/>
			{error && <ErrorMessage>{error}</ErrorMessage>}
		</FormElementContainer>
	)
})

Textarea.displayName = 'Textarea'

export default memo(Textarea)
